import React from 'react'
// import { withRouter } from 'react-router-dom'
// import { compose } from 'recompose'
import { Button, Container, Grid } from 'semantic-ui-react'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null, errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    handleSubmit = () => {
        window.location.replace(`/`)
        // this.props.history.replace(`/`)
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            return (
                <div className="module errorBoundary">
                    <Container>
                        <Grid className="grid-header">
                            <Grid.Column width={16} textAlign="center">
                                <h2>Something went wrong.</h2>
                            </Grid.Column>
                            <Grid.Column width={16} textAlign="center">
                                <Button className="btn _back" onClick={this.handleSubmit}>Back</Button>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <details style={{ whiteSpace: 'pre-wrap' }}>
                                    {this.state.error && this.state.error.toString()}
                                    <br />
                                    {this.state.errorInfo.componentStack}
                                </details>
                            </Grid.Column>
                        </Grid>
                    </Container>
                </div>
            );
        }
        return this.props.children;
    }
}


// export default compose(
//     withRouter
// )(ErrorBoundary)
export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/app/components/features/share/ErrorBoundary.js